var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#FF8E8E",
    stroke: "#FF8E8E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6377 11.8057L16.3721 9.07129C16.7275 8.74316 16.7275 8.19629 16.3721 7.86816L15.7705 7.2666C15.4424 6.91113 14.8955 6.91113 14.5674 7.2666L11.833 10.001L9.07129 7.2666C8.74316 6.91113 8.19629 6.91113 7.86816 7.2666L7.2666 7.86816C6.91113 8.19629 6.91113 8.74316 7.2666 9.07129L10.001 11.8057L7.2666 14.5674C6.91113 14.8955 6.91113 15.4424 7.2666 15.7705L7.86816 16.3721C8.19629 16.7275 8.74316 16.7275 9.07129 16.3721L11.833 13.6377L14.5674 16.3721C14.8955 16.7275 15.4424 16.7275 15.7705 16.3721L16.3721 15.7705C16.7275 15.4424 16.7275 14.8955 16.3721 14.5674L13.6377 11.8057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.baf4893c88b3126e3dcbbf00aedcb401.svg";
export { ForwardRef as ReactComponent };